import { render } from "./MOverlay.vue?vue&type=template&id=4084224f&scoped=true"
import script from "./MOverlay.vue?vue&type=script&lang=js"
export * from "./MOverlay.vue?vue&type=script&lang=js"

import "./MOverlay.vue?vue&type=style&index=0&id=4084224f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4084224f"]])

export default __exports__